import { buildI18nextResources, I18NEXT_NAMESPACES, normalizeLocale } from "@kupikupi/i18n";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export async function initI18n(locale: "ru" | "zh" = "ru") {
  const resources = await buildI18nextResources(locale);
  await i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: "ru",
    defaultNS: "common",
    ns: [...I18NEXT_NAMESPACES],
    // 共享 locale JSON 由 next-intl(web)撰写,占位符是单花括号 `{x}`,
    // 而 i18next 默认按双花括号 `{{x}}` 插值 → 单花括号原样不替换,导致
    // 全站 `t("k", { x })` 渲染出字面 `{x}`。把前后缀对齐成单花括号,
    // 让 mini 的 i18next 与共享 JSON 一致(locale 全为简单 `{x}` 占位,
    // 无 ICU plural/select,故安全)。
    interpolation: { escapeValue: false, prefix: "{", suffix: "}" },
  });
  return { i18n, normalizedLocale: normalizeLocale(locale) };
}
